<template>
  <table class="table table-bordered table-hover template-table">
    <thead>
      <tr>
        <th> #ID </th>
        <th> Name </th>
        <th> Created At </th>
        <th> Last Updated </th>
        <th> Stream </th>
        <th> Actions </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(template, index) in templates" :key="index">
        <td>{{ template.id }}</td>
        <td>{{ template.name }}</td>
        <td>{{ template.created_at }}</td>
        <td>{{ template.updated_at }}</td>
        <td>{{ template.template.stream }}</td>
        <td>
          <div class="template-table-actions-cell d-flex">
            <a v-perms="['api.templates.update']"
               class="btn btn-ss btn-sm"
               :href="`/templates/${template.id}/edit`">
              <i class="la la-edit" />Edit
            </a>
            <button v-perms="['api.templates.destroy']"
                    type="button"
                    class="btn btn-ss btn-sm"
                    @click="deleteTemplate(template.id)">
              <i class="la la-remove" />Delete
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  data: () => ({
    templates: [],
  }),
  async mounted() {
    if (this.permissionsCanAccessFeature('templates')) {
      const res = await axios.get(`/api/v1/templates`);
      this.templates = res.data.data;
    }
  },
  methods: {
    async deleteTemplate(id) {
      const name = this.templates.find(t => t.id === id).name;
      const res = (await axios.delete(`/api/v1/templates/${id}`)).data;
      if (res.success) {
        toastr.success(`Template '${name}' successfully deleted.`);
        this.templates.splice(this.templates.findIndex(t => t.id === id), 1);
      } else {
        toastr.error(`Error trying to delete template '${name}': ${res.message}`);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.template-table {
  td {
    vertical-align: middle;
  }
}
</style>
